import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { Colors, Spacing } from "@paclife/plds.tokens";

import Typography from "common/Typography/Typography";
import OverflowMenu from "common/OverflowMenu/OverflowMenu";
import EditModal from "components/EditModal/EditModal";

import { addCEmail } from "api/cemail";

const Wrapper = styled.div`
    display: flex;
    margin-bottom: ${Spacing[32]};
`;

const Label = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing[8]};
    white-space: nowrap;
`;

const Text = styled(Typography)`
    display: block;
    color: ${({ color }) => color};
    &.label-text {
        margin-right: ${Spacing[4]};
    }
`;

const AddCEmail = () => {
    const { t } = useTranslation("notification");
    const [editModal, setEditModal] = useState(false);

    const openEditModal = () => {
        setEditModal(true);
    };

    const closeEditModal = () => {
        setEditModal(false);
    };

    return (
        <div>
            <Wrapper>
                <OverflowMenu
                    icon="add"
                    color={Colors.blue600}
                    onClick={openEditModal}
                />
                <div>
                    <Label>
                        <Text
                            className="label-text"
                            variant="caption"
                            display="block"
                            color={Colors.textBodyLight}
                            bold
                        >
                            {t("other")}
                        </Text>
                    </Label>
                    <Text color={Colors.textBodyLight}>
                        Add a new email address
                    </Text>
                </div>
            </Wrapper>
            {editModal && (
                <EditModal
                    closeModal={closeEditModal}
                    update={addCEmail}
                    type="add"
                />
            )}
        </div>
    );
};

export default AddCEmail;
